/**
 * Format money for catalog / client UI (display currency, usually USD).
 */
export function formatDisplayMoney(amount, currency = 'USD', locale = 'en-US') {
  const value = Number(amount);
  const code = (currency || 'USD').toUpperCase();
  if (Number.isNaN(value)) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: code,
      }).format(0);
    } catch {
      return `${code} 0.00`;
    }
  }
  try {
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency: code,
    }).format(value);
  } catch {
    return `${code} ${value.toFixed(2)}`;
  }
}

/**
 * Payment amount in catalog/display currency (USD).
 * Prefer display_amount; Stripe settlement CAD stays on `amount`.
 */
export function paymentCatalogAmount(payment) {
  if (payment?.display_amount != null && payment.display_amount !== '') {
    return Number(payment.display_amount) || 0;
  }
  return Number(payment?.amount || 0) || 0;
}

/**
 * Platform fee portion in catalog/display currency.
 */
export function paymentCatalogPlatformFee(payment) {
  if (payment?.platform_fee_display != null && payment.platform_fee_display !== '') {
    return Number(payment.platform_fee_display) || 0;
  }
  return Number(payment?.platform_fee || 0) || 0;
}

/** Vendor share for a payment row, in display currency. */
export function paymentVendorShareDisplay(payment) {
  return paymentCatalogAmount(payment) - paymentCatalogPlatformFee(payment);
}

export default formatDisplayMoney;
